export default __webpack_public_path__ + "static/media/CookiesChocolateClassic.27660a41.png";